<template>
  <div class="container my-4">
    <div v-if="imageUrl" class="cropper-wrapper text-center">
      <img ref="imageRef" :src="imageUrl" class="img-fluid" />
    </div>
    <p v-if="imageUrl" class="text-muted text-center mt-2">
      拖移邊框確認需裁切的圖片範圍
    </p>

    <div class="mt-4 text-center">
      <button @click="cropImage" class="btn btn-primary font-weight-bold bg-blue-main py-2 px-4">
        確認並送出
      </button>
    </div>
  </div>
</template>

<script>
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css';

export default {
  props: {
    imageFile: File
  },
  data() {
    return {
      cropper: null,
      imageUrl: ''
    }
  },
  watch: {
    imageFile: {
      immediate: true,
      handler(newFile) {
        if (newFile) {
          this.imageUrl = URL.createObjectURL(newFile)
        }
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.imageRef) {
        this.cropper = new Cropper(this.$refs.imageRef, {
          aspectRatio: NaN,
          viewMode: 1
        })
      }
    })
  },
  beforeDestroy() {
    if (this.cropper) {
      this.cropper.destroy()
    }
    URL.revokeObjectURL(this.imageUrl)
  },
  methods: {
    cropImage() {
      if (!this.cropper) return
      this.cropper.getCroppedCanvas().toBlob((blob) => {
        if (blob) {
          this.$emit('next', blob)
        }
      }, 'image/jpeg')
    }
  }
}
</script>


<style scoped>
.cropper-wrapper {
  max-width: 100%;
  max-height: 500px;
  overflow: hidden;
}
.submit_btn {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  border: 2px solid #915b43;
  color: #ffffff;
  background: #915b43;
  border-radius: 4px;
}
</style>
